"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sport = void 0;
var Sport;
(function (Sport) {
    Sport["GOLF"] = "golf";
    Sport["SOCCER"] = "soccer";
    Sport["FOOTBALL"] = "football";
    Sport["BASEBALL"] = "baseball";
    Sport["BASKETBALL"] = "basketball";
    Sport["HOCKEY"] = "hockey";
})(Sport || (exports.Sport = Sport = {}));
